<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div>
        <!-- 用户信息表格 -->
        <el-table :data="allUserList">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="账号" prop="UserNO" align="center"></el-table-column>
          <el-table-column label="名称" prop="UserName" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)"
                >角色配置</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15, 50]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 配置角色信息的会话框 -->
    <el-dialog title="角色配置" :visible.sync="editDialogVisible" width="40%" @close="editDialogClose">
      <div class="test1">
        <h3 class="H3">选择角色：</h3>
        <el-select size="mini" v-model="roleList.ID" placeholder="请选择要添加的角色">
          <el-option v-for="item in roleList" :key="item.ID" :label="item.RoleName" :value="item.ID"> </el-option>
        </el-select>
        <div class="button1">
          <el-button size="mini" type="primary" @click="editUserRole()">确 定</el-button>
        </div>
      </div>
      <el-table :data="userRoleList">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="ID" prop="roleID" align="center"></el-table-column>
        <el-table-column label="角色名称" prop="roleName" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteUserRole(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_user'
            },
            getTypeList1: {
                page: '1',
                limit: '10000',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            // 用户信息表
            allUserList: [],
            // 角色信息表
            roleList: [],
            // 数据总条数
            total: 0,
            //控制修改表单的显示与隐藏
            editDialogVisible: false,
            // 编辑信息的表单数据
            editForm: {},
            bindList: {
                UserID: ''
            },
            //用户角色绑定表名
            tableName1: 'main_user_role',
            // 用户绑定的角色信息表
            userRoleList: []

        }
    },
    created () {
        this.getAllUserList()
        this.getAllUserList1()
        this.getRoleList()
    },
    methods: {
        // 调用接口获取用户信息
        async getAllUserList () {
            const { data: res } = await this.$http.get('/User/UserSelectAll', { params: this.getTypeList })
            console.log(res.data)
            this.allUserList = res.data
        },
        async getAllUserList1 () {
            const { data: res } = await this.$http.get('/User/UserSelectAll', { params: this.getTypeList1 })
            this.total = res.data.length
        },
        // 调用接口获取角色信息
        async getRoleList () {
            const { data: res } = await this.$http.get('/User/RoleAll', { params: this.getTypeList })
            console.log(res)
            this.roleList = res.data
        },
        // 展示角色配置信息的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.getTypeList.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.bindList.UserID = res.data[0].ID
            this.getUserRoleByID()
        },
        // 调用接口绑定人员角色
        async editUserRole () {
            let params = new URLSearchParams();
            params.append("RoleID", this.roleList.ID)
            params.append("UserID", this.bindList.UserID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/InsertUserRole', params)
            if (res.code != 1) {
                return this.$message.error('配置失败，请勿重复添加！')
            } else {
                this.$message.success('配置成功！')
            }
            this.getUserRoleByID()
        },
        // 根据用户ID查询绑定角色
        async getUserRoleByID () {
            let params = new URLSearchParams();
            params.append("UserID", this.bindList.UserID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/User/SelectUserRoleIDAndRoleNameByUserID', { params })
            console.log(res.data)
            this.userRoleList = res.data
        },
        // 调用接口删除用户绑定角色
        async deleteUserRole (scope) {
            let params = new URLSearchParams();
            params.append("RoleID", scope.row.roleID)
            params.append("UserID", this.bindList.UserID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/DeleteUserRole', params)
            this.getUserRoleByID()
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getAllUserList()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getAllUserList()
        },
    }
}
</script>

<style lang="less" scoped>
.btn1 {
  margin-bottom: 10px;
}
.test1 {
  display: flex;
}
.H3 {
  font-weight: 700;
  transform: translateY(-50%); /**上移元素**/
  -ms-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  margin-right: 10px;
}
.button1 {
  transform: translateX(15%); /**右移元素**/
  -ms-transform: translateX(15%);
  -webkit-transform: translateX(15%);
}
</style>

